(() => {
  if (window.ssDesktopMenuReady) return;
  window.ssDesktopMenuReady = true;
  const desktop = window.matchMedia('(min-width: 990px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  const timers = new WeakMap();
  const navs = () => Array.from(document.querySelectorAll('.ss-mega-nav'));
  const disclosures = nav => Array.from(nav.querySelectorAll('details.mega-menu'));
  const cancelTimers = nav => {
    const pending = timers.get(nav);
    if (!pending) return;
    clearTimeout(pending.open);
    clearTimeout(pending.close);
  };
  const position = nav => {
    const header = nav.closest('.header-wrapper');
    if (!header) return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.round(header.getBoundingClientRect().bottom)}px`);
    header.preventHide = Boolean(nav.querySelector('details[open]'));
  };
  const panelTransitions = new WeakMap();
  const stopPanelMotion = nav => {
    const previous = panelTransitions.get(nav);
    if (previous) {
      previous.animation.onfinish = null;
      previous.animation.cancel();
      previous.fade?.cancel();
      previous.panel.style.overflow = '';
      panelTransitions.delete(nav);
    }
    nav.removeAttribute('data-ss-switching');
  };
  const close = (nav, except) => {
    if (!except) stopPanelMotion(nav);
    disclosures(nav).forEach(details => {
      if (details === except) return;
      details.open = false;
      details.querySelector('summary').setAttribute('aria-expanded', 'false');
    });
    position(nav);
  };
  const open = (nav, details) => {
    if (!desktop.matches || !nav.isConnected || details.open) return;
    const previous = nav.querySelector('details[open]');
    const oldPanel = previous?.querySelector('summary').nextElementSibling;
    const startHeight = oldPanel?.getBoundingClientRect().height;
    stopPanelMotion(nav);
    if (previous) nav.setAttribute('data-ss-switching', '');
    // Open the incoming disclosure first, so the shared backdrop never closes.
    details.open = true;
    close(nav, details);
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
    position(nav);
    const panel = details.querySelector('summary').nextElementSibling;
    if (!previous || !panel.animate || reducedMotion.matches) {
      nav.removeAttribute('data-ss-switching');
      return;
    }
    const endHeight = panel.getBoundingClientRect().height;
    panel.style.overflow = 'hidden';
    const animation = panel.animate([{ height: `${startHeight}px` }, { height: `${endHeight}px` }], {
      duration: 220, easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
    });
    const list = panel.querySelector('.mega-menu__list');
    const fade = list?.animate([{ opacity: 0.35 }, { opacity: 1 }], {
      duration: 150, easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
    });
    panelTransitions.set(nav, { animation, fade, panel });
    animation.onfinish = () => {
      panel.style.overflow = '';
      panelTransitions.delete(nav);
      nav.removeAttribute('data-ss-switching');
    };
  };
  const shoesGroups = menu => Array.from(menu.children).filter(group => group.classList.contains('ss-shoes-group'));
  const selectShoesGroup = (menu, selected, animate = true) => {
    if (!desktop.matches || !selected.querySelector('ul')) return;
    // Hover, focus and click can all target the same brand. Do not replay its
    // animation or update the visible panel unless the selection changes.
    if (animate && selected.hasAttribute('data-selected') && !selected.querySelector('ul').hidden) return;
    menu.ssPanelAnimation?.cancel();
    shoesGroups(menu).forEach(group => {
      const panel = group.querySelector('ul');
      const active = group === selected;
      group.toggleAttribute('data-selected', active);
      const trigger = group.querySelector('button');
      if (trigger) trigger.setAttribute('aria-pressed', String(active));
      if (panel) panel.hidden = !active;
    });
    const panel = selected.querySelector('ul');
    if (animate && panel.animate && !reducedMotion.matches) {
      menu.ssPanelAnimation = panel.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 160, easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
      });
    }
  };
  const syncShoes = nav => nav.querySelectorAll('.ss-shoes-menu').forEach(menu => {
    const groups = shoesGroups(menu);
    groups.forEach(group => {
      const panel = group.querySelector('ul');
      if (!panel) return;
      const count = panel.children.length;
      const columns = count > 6 ? 2 : 1;
      panel.style.setProperty('--ss-model-columns', columns);
      panel.style.setProperty('--ss-model-rows', Math.max(1, Math.ceil(count / columns)));
    });
    const selected = groups.find(group => group.hasAttribute('data-selected')) || groups.find(group => group.querySelector('ul'));
    menu.ssPanelAnimation?.cancel();
    if (desktop.matches && selected) {
      menu.style.setProperty('--ss-shoes-count', groups.length);
      selectShoesGroup(menu, selected, false);
      menu.classList.add('ss-shoes-ready');
    } else {
      menu.classList.remove('ss-shoes-ready');
      groups.forEach(group => {
        const panel = group.querySelector('ul');
        if (panel) panel.hidden = false;
      });
    }
  });
  const initialize = () => navs().forEach(nav => {
    if (initialized.has(nav)) return;
    initialized.add(nav);
    const pending = {};
    timers.set(nav, pending);
    nav.querySelectorAll('.ss-shoes-menu').forEach(menu => {
      shoesGroups(menu).forEach(group => {
        const originalLink = group.querySelector('a');
        if (!originalLink || !group.querySelector('ul')) return;
        const link = document.createElement('button');
        link.type = 'button';
        link.className = originalLink.className;
        link.classList.remove('mega-menu__link--active');
        link.id = originalLink.id;
        link.textContent = originalLink.textContent;
        link.setAttribute('aria-pressed', 'false');
        originalLink.replaceWith(link);
        link.addEventListener('click', () => selectShoesGroup(menu, group));
        const select = () => {
          // Never hide the panel currently holding keyboard focus on a stray hover.
          const focused = menu.querySelector('ul:not([hidden])');
          if (focused?.contains(document.activeElement) && !group.contains(document.activeElement)) return;
          if (!group.hasAttribute('data-selected')) selectShoesGroup(menu, group);
        };
        link.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') select();
        });
        link.addEventListener('focus', () => selectShoesGroup(menu, group));
      });
    });
    syncShoes(nav);
    disclosures(nav).forEach(details => {
      const summary = details.querySelector('summary');
      summary.addEventListener('pointerdown', event => { pending.pointerType = event.pointerType; });
      summary.addEventListener('keydown', () => { pending.pointerType = 'keyboard'; });
      summary.addEventListener('click', event => {
        if (!desktop.matches || event.detail === 0) return;
        const pointerType = event.pointerType || pending.pointerType || 'mouse';
        if (pointerType !== 'mouse') return;
        // Mouse uses hover only. Keep native activation for keyboard and touch,
        // and stop the theme's click listener from changing aria-expanded.
        event.preventDefault();
        event.stopImmediatePropagation();
        summary.setAttribute('aria-expanded', String(details.open));
      }, { capture: true });
      summary.addEventListener('pointerenter', event => {
        if (!desktop.matches || event.pointerType !== 'mouse') return;
        cancelTimers(nav);
        const delay = nav.querySelector('details[open]') ? 35 : 110;
        pending.open = setTimeout(() => open(nav, details), delay);
      });
      const panel = summary.nextElementSibling;
      panel.addEventListener('pointerenter', event => {
        if (desktop.matches && event.pointerType === 'mouse') cancelTimers(nav);
      });
      details.addEventListener('toggle', () => {
        if (!desktop.matches) return;
        if (details.open) close(nav, details);
        details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
        position(nav);
      });
    });
    const header = nav.closest('.header-wrapper');
    header.addEventListener('pointerenter', event => {
      if (desktop.matches && event.pointerType === 'mouse') cancelTimers(nav);
    });
    const scheduleClose = event => {
      if (!desktop.matches || event.pointerType !== 'mouse') return;
      cancelTimers(nav);
      pending.close = setTimeout(() => {
        const active = nav.querySelector('details[open]');
        if (!active) return;
        const summary = active.querySelector('summary');
        const mouseFocusedTrigger = document.activeElement === summary && pending.pointerType === 'mouse';
        if (!active.contains(document.activeElement) || mouseFocusedTrigger) close(nav);
      }, 280);
    };
    header.addEventListener('pointerleave', scheduleClose);
    // SS: przyciemnione tlo (.ss-mega-backdrop) jest w naglowku i zakrywa strone, wiec kursor
    // nigdy "nie wychodzi" z naglowka. Wjechanie myszka na tlo traktujemy jak wyjscie z menu.
    header.querySelectorAll('.ss-mega-backdrop').forEach(backdrop => {
      backdrop.addEventListener('pointerenter', scheduleClose);
    });
  });
  document.addEventListener('pointerdown', event => {
    if (!desktop.matches) return;
    navs().forEach(nav => {
      if (!nav.contains(event.target)) {
        cancelTimers(nav);
        close(nav);
      }
    });
  });
  document.addEventListener('keydown', event => {
    if (!desktop.matches || event.key !== 'Escape') return;
    navs().forEach(nav => {
      cancelTimers(nav);
      const active = nav.querySelector('details[open]');
      if (!active) return;
      const restoreFocus = active.contains(document.activeElement);
      close(nav);
      if (restoreFocus) active.querySelector('summary').focus({ preventScroll: true });
    });
  });
  desktop.addEventListener('change', () => navs().forEach(nav => {
    cancelTimers(nav);
    close(nav);
    syncShoes(nav);
  }));
  reducedMotion.addEventListener('change', () => {
    if (!reducedMotion.matches) return;
    navs().forEach(nav => {
      stopPanelMotion(nav);
      nav.querySelectorAll('.ss-shoes-menu').forEach(menu => menu.ssPanelAnimation?.cancel());
    });
  });
  let frame;
  const updatePosition = () => {
    if (!desktop.matches || frame) return;
    frame = requestAnimationFrame(() => {
      navs().forEach(nav => { if (nav.querySelector('details[open]')) position(nav); });
      frame = null;
    });
  };
  window.addEventListener('resize', updatePosition, { passive: true });
  window.addEventListener('scroll', updatePosition, { passive: true });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.ss-mega-nav').forEach(cancelTimers);
  });
  initialize();
})();
